export default {
  tiles: [
    {
      index: 1,
      backgroundColor: '#005FB9',
      textColor: 'white',
      entityName: 'first_time_home_buyer_smorg',
      eyebrow: 'Home sweet home',
      eyebrowColor: 'white',
      description:
        'Check out tips from our experts on landing your first home.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: "Let's do this",
      buttonUrl:
        'https://www.nerdwallet.com/article/mortgages/tips-for-first-time-home-buyers?trk=hp_smorg_tips_home_buyers&trk_copy=hp_smorg_tips_home_buyers',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 2,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'socially_responsible_investing_smorg',
      eyebrow: 'Make an impact',
      eyebrowColor: 'neutral-darker',
      description:
        'Learn how to invest in Black-owned businesses and green companies.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Show me more',
      buttonUrl:
        'https://www.nerdwallet.com/article/investing/socially-responsible-investing?trk=hp_smorg_socially_responsible_investing&trk_copy=hp_smorg_socially_responsible_investing',
      buttonColor: '',
      quoteText: '',
      quoteColor: 'neutral-darkest',
      quoteSize: '2',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 3,
      backgroundColor: '#E3FAF2',
      textColor: '',
      entityName: 'manage_credit_score_smorg',
      eyebrow: 'Moving on up',
      eyebrowColor: 'neutral-darker',
      description: 'Build your credit with this simple recipe.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Yes please',
      buttonUrl:
        'https://www.nerdwallet.com/article/finance/simple-way-manage-credit-score?trk=hp_smorg_manage_credit_score&trk_copy=hp_smorg_manage_credit_score',
      buttonColor: '',
      quoteText: '',
      quoteColor: 'neutral-darker',
      quoteSize: '1',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 4,
      backgroundColor: '#F5F5F5',
      textColor: 'neutral-darkest',
      entityName: 'podcast_guide_smorg',
      eyebrow: 'Worth A Listen',
      eyebrowColor: 'neutral-darker',
      description:
        'Have a money goal? Turn to our SmartMoney podcast for hacks, how-tos and more.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Tune in',
      buttonUrl:
        'https://www.nerdwallet.com/blog/podcast/?trk=hp_smorg_smartmoneypodcast&trk_copy=hpsmartmoneypodcast',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 5,
      backgroundColor: '#EEF7FF',
      textColor: 'neutral-darkest',
      entityName: 'pay_per_mile_car_insurance_smorg',
      eyebrow: 'Start saving',
      eyebrowColor: 'neutral-darker',
      description:
        "Working from home? Here's how to spend less on car insurance.",
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Get answers',
      buttonUrl:
        'https://www.nerdwallet.com/article/insurance/pay-per-mile-car-insurance?trk=hp_smorg_car_insurance&trk_copy=hp_smorg_car_insurance',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 6,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'banking_guide_smorg',
      eyebrow: 'How interesting...',
      eyebrowColor: 'neutral-darker',
      description: 'Discover banks that pay the highest interest rates on CDs.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Yay free money',
      buttonUrl:
        'https://www.nerdwallet.com/best/banking/cd-rates?trk=hp_smorg_bestcds&trk_copy=hpbestcds',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
  ],
};
